import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Tag, Row, Table, Button, Modal, Form, Spin, InputNumber, Col, Select } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { APP_DATE_FORMAT, AUTHORITIES } from 'app/config/constants';
import { getEcole } from '../ecole/ecole.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getEcoleVirements, demandeVirement as requestDemandeVirement, soldeTotalByEcole } from './virement.reducer';
import { CloseOutlined } from '@ant-design/icons';
import CountUp from 'react-countup';
import { JhiItemCount, JhiPagination, getSortState, TextFormat } from 'react-jhipster';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Storage } from 'react-jhipster';
import axios from 'axios';
import { useCheckIsAnneeInactive } from 'app/hooks/useCheckIsAnneeActive';

export const Virement = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId: string }>) => {
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );
  const [form] = Form.useForm();
  const totalItems = useAppSelector(state => state.virement.totalItems);
  const dispatch = useAppDispatch();
  const [isProcessing, setProcessing] = useState(false);
  const [isSendDemand, setIsSendDemand] = useState(false);
  const virement = useAppSelector(state => state.virement.entity);
  const ecoleVirements = useAppSelector(state => state.virement.entities);
  const [soldeTotal, setSolde] = useState(0);
  const loading = useAppSelector(state => state.virement.loading);
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const isComptable = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));
  const isDirecteur = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.DIRECTEUR]));
  const inactiveAnnee = useCheckIsAnneeInactive(props.match.params.anneeScolaireId);

  const hasAccess = isAdmin || isDirecteur || isComptable;
  const apiUrl = 'api/comptes/solde';
  const token = Storage.local.get('jhi-authenticationToken') || Storage.session.get('jhi-authenticationToken');
  const getSoldeCompte = () => {
    if (token) {
      axios
        .get(`${apiUrl}/${props.match.params.ecoleid}`, {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        })
        .then(response => {
          setSolde(response.data);
        });
    }
  };
  useEffect(() => {
    dispatch(getSession());
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getSoldeCompte);
    sortEntities();
  }, []);
  const columns = [
    {
      title: 'Date Emission',
      dataIndex: 'dateEmission',
      key: 'dateEmission',
      render: dateEmission => <TextFormat type="date" value={dateEmission} format={APP_DATE_FORMAT} />,
      align: 'center' as const,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      align: 'center' as const,
    },
    {
      title: 'Montant Reçu',
      dataIndex: 'montant',
      key: 'montant',
      align: 'center' as const,
    },
    {
      title: 'Statut',
      dataIndex: 'statutVirement',
      key: 'statutVirement',
      render: statutVirement =>
        statutVirement === 'ENCOURS' ? (
          <Tag color="#F28E19">Demande Encours</Tag>
        ) : statutVirement === 'VALIDE' ? (
          <Tag color="blue">Demande validée</Tag>
        ) : (
          <Tag color="#999">{statutVirement}</Tag>
        ),
      align: 'center' as const,
    },
  ];

  const dataSource = ecoleVirements
    .map((vi, i) => ({
      id: vi.id,
      dateEmission: vi.dateEmission,
      description: vi.description,
      montant: vi.montant + ' CFA',
      statutVirement: vi.statutVirement,
    }))
    .reverse();

  const demandeVirement = values => {
    const entity = {
      ...virement,
      ...values,
      ecoleId: props.match.params.ecoleid,
      anneeScolaireId: props.match.params.anneeScolaireId,
    };
    setIsSendDemand(true);
    dispatch(requestDemandeVirement(entity)).then(() => {
      setIsSendDemand(false);
    });
    form.resetFields();
  };

  const handlePagination = (currentPage: number) => {
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });
  };

  const virementList = () => {
    const entity = {
      page: paginationState.activePage - 1,
      ecoleId: props.match.params.ecoleid,
      anneeScolaireId: props.match.params.anneeScolaireId,
      size: paginationState.itemsPerPage,
    };
    dispatch(getEcoleVirements(entity));
  };

  const sortEntities = () => {
    virementList();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}`);
    }
  };

  const handleOnFinish = values => {
    setProcessing(true);
    demandeVirement(values);
    form.resetFields;
  };

  const onSearch = vals => {
    const entity = {
      ...vals,
      ecoleId: props.match.params.ecoleid,
      anneeScolaireId: props.match.params.anneeScolaireId,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getEcoleVirements(entity));
  };

  const handleChange = () => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      anneeScolaireId: props.match.params.anneeScolaireId,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getEcoleVirements(entity));
  };

  const handleCancel = () => {
    Modal.destroyAll();
    form.resetFields();
  };
  const handleDemandeVirement = () => {
    Modal.info({
      title: (
        <div>
          <span>Demande de virement</span>
          <Button type="text" onClick={handleCancel} style={{ float: 'right' }}>
            <CloseOutlined style={{ color: '#F28E19' }} />
          </Button>
        </div>
      ),
      content: (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100vh' }}>
          <div style={{ width: '400px' }}>
            <Form
              form={form}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              layout="vertical"
              size="large"
              initialValues={{ virement: virement || null }}
              onFinish={handleOnFinish}
            >
              <Form.Item
                name="montant"
                label={<span style={{ fontWeight: 'bold' }}>Montant</span>}
                rules={[
                  {
                    type: 'number',
                    min: 0,
                    max: soldeTotal,
                    message: `Solde insuffisant. Votre solde est ${soldeTotal} FCFA`,
                  },
                  { required: true, message: 'Veuillez saisir le montant' },
                ]}
              >
                <InputNumber
                  min={0}
                  controls={false}
                  style={{
                    width: '100%',
                    borderRadius: '8px',
                    padding: '0 10px',
                    height: '45px',
                    lineHeight: '40px',
                  }}
                  className="form-control"
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      ),
      okText: 'Suivant',
      onOk() {
        try {
          setProcessing(true);
          form.submit();
        } catch (error) {
          console.error(error);
        } finally {
          setProcessing(false);
        }
      },
      width: '50%',
      okButtonProps: { disabled: isProcessing, style: { background: '#F28E19', color: 'white', border: '1px solid #F28E19' } },
    });
  };

  return (
    <div>
      <h2>Historiques Virements</h2>
      <Row className="p-2 justify-content-center">
        <Row className="p-2 justify-content-center">
          {loading ? (
            <Spin tip="Chargement..." />
          ) : (
            <h4>
              {' '}
              Solde:{' '}
              <strong>
                <CountUp end={soldeTotal} separator="." /> FCFA
              </strong>
            </h4>
          )}
        </Row>
      </Row>

      <h2 id="classe-heading" data-cy="ClasseHeading">
        {hasAccess && (
          <div style={{ textAlign: 'right' }}>
            <Button
              onClick={handleDemandeVirement}
              disabled={isSendDemand || inactiveAnnee}
              style={{
                background: isSendDemand || inactiveAnnee ? '#ccc' : '#F28E19',
                color: 'white',
                borderRadius: '8px',
                border: `1px solid ${isSendDemand || inactiveAnnee ? '#ccc' : '#F28E19'}`,
              }}
            >
              {isSendDemand ? (
                <Spin />
              ) : (
                <>
                  <FontAwesomeIcon icon="plus" style={{ marginRight: '8px' }} />
                  Demande de virements
                </>
              )}
            </Button>
          </div>
        )}
      </h2>
      <Form name="basic" layout="inline" onFinish={onSearch}>
        <Row className="p-1">
          <Col span={20} sm={20} md={20} xs={17} xxl={20} xl={20} lg={24}>
            <Form.Item name="statutVirement">
              <Select placeholder="Status" allowClear onClear={handleChange}>
                <Select.Option value="ENCOURS">
                  <Tag color="red">En attente</Tag>
                </Select.Option>
                <Select.Option value="VALIDE">
                  <Tag color="green">Validée</Tag>
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={1} sm={1} md={1} xs={1} xxl={1} xl={1} lg={3}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                <FontAwesomeIcon icon={faSearch} />
              </Button>
            </Form.Item>
          </Col>
        </Row>

        <div className="table-responsive">
          <Spin spinning={loading} tip="Chargement...">
            <Table dataSource={dataSource} columns={columns} pagination={false} style={{ textAlign: 'center' }} bordered />
          </Spin>
        </div>
        {totalItems ? (
          <div className={ecoleVirements && ecoleVirements.length > 0 ? 'table-responsive' : 'd-none'}>
            <Row className="justify-content-center">
              <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
            </Row>
            <Row className="justify-content-center">
              <JhiPagination
                activePage={paginationState.activePage}
                onSelect={handlePagination}
                maxButtons={5}
                itemsPerPage={paginationState.itemsPerPage}
                totalItems={totalItems}
              />
            </Row>
          </div>
        ) : (
          ''
        )}
      </Form>
    </div>
  );
};
export default Virement;
